import React, { useState, useEffect } from 'react';
import ReactTable from 'Components/ReactTable/ReactTable';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import {
    ViewBeneficiary as BENE_SELECT,
    DeleteBeneficiary as BENE_DELETE,
    MoneyTransfer as DMT_TRANSFER,
    GenerateOTPForSender as GENERATE_OTP_ForMoneyTransfer,
    GetSplitAmountForTransactionI4Ticket as GETSPLITAMOUNT
} from 'Components/Api/NovityDMTAPI';
import { LOGOUT } from 'ConstComponents';
import { DMTTransactionConfirmation } from 'Components/Alert/DMTTransactionConfirmation';
import { DMTTransactionOTPConfirmation } from 'Components/Alert/DMTTransactionOTPConfirmation';
import { useHistory } from 'react-router';
import { useLocation } from 'react-router-dom';
import usePosition from 'Components/Posistion';
import { OTPModal } from 'Components/Modal/OTPModal';
import * as Yup from 'yup';
import {
    MONEY_TRANSFER_CODE,
    MONEY_TRANSFER_OPERATOR_TRANSFER_CODE,
    MONEY_TRANSFER_OPERATOR_VERIFY_CODE,
    PLEASE_PROVIDE_VALID
} from 'Components/Helper/Messages';

import { TransactionResponse } from 'Components/Alert/TransactionResponse';
var mobile = '';

export default function BeneficiaryList({
    senderNo,
    ActiveDMTName,
    Lat,
    Long,
    senderName,
    setIsError,
    setSeverity,
    setLoading,
    BankPipe,
    setResponseMessage,
    formRef
}) {
    const classes = commonStyle();
    const [mainColumns, setMainColumns] = useState([]);
    const [list, setList] = useState([]);
    const history = useHistory();
    const location = useLocation();
    const [isAlertOpen, setIsAlertOpen] = useState(false);
    const [serviceCode, setserviceCode] = useState(MONEY_TRANSFER_CODE);
    const [confirmAlertRequest, setConfirmAlertRequest] = useState({});
    const Mobile = location?.state?.Mobile;
    const { latitude, longitude } = usePosition(); 
    mobile = senderNo;
    const [isPin] = useState(localStorage.getItem('IsPin'));
    const [isResponseAlertOpen, setIsResponseAlertOpen] = useState(false);
    const [ResponseAlert, setResponseAlert] = useState({});
    const [isOtpDialogOpen, setIsOtpDialogOpen] = useState(false);
    const [senderMobile, setSenderMobile] = useState('');
    const [openOTP, setOpenOTP] = useState(false);
    const [VerifyOTPParams, setVerifyOTPParams] = useState();
    const [modalErrorMessage, setModalErrorMessage] = useState('');
    const [otpRefID, setOTPRefID] = useState(false);
    const [isBeneVerifyOpen, setIsBeneVerifyOpen] = useState(false);
    useEffect(() => {
        select();
        createColumns();
    }, [mobile]);

    const select = async () => {
        setList([]);
        setLoading(true);
        setIsError(false);

        if (senderNo === undefined) return;

        if (senderNo === '') return;

        var beneReqObj = JSON.stringify({
            Mobile: senderNo,
            DMTName: ActiveDMTName,
            BankPipe: BankPipe
        });
        var response = await BENE_SELECT(beneReqObj);

        setLoading(false);
        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setSeverity('error');
            setIsError(true);
            setResponseMessage(response.data);
            return;
        }

        var data = JSON.parse(response.data);
        setSenderMobile(data[0].SenderID);
        setList(data);
    };
    const GetSplitAmountForMultipleTransaction = async (request) => {
        setIsOtpDialogOpen(false);
        let jsonObj = {
            Mobile: senderMobile,
            BeneMobile: request.BeneMobile,
            Name: request.BeniName,
            BeniName: request.BeniName,
            SenderName: senderName,
            BankName: request.BankName,
            AccountNo: request.AccountNumber,
            IFSC: request.IFSC,
            BeneficiaryID: request.BeneficiaryID,
            SenderID: request.SenderID,
            PaymentType: request.PaymentType,
            RechargePin: request.RechargePin,
            Remark: request.Remark,
            DMTName: ActiveDMTName,
            Amount: request.Amount,
            BankPipe: BankPipe,
            Latitude: latitude,
            Longitude: longitude
        };
        setIsError(false);
        setLoading(true);
        var apirequest = JSON.stringify(jsonObj);
        var response = await GETSPLITAMOUNT(apirequest); 
        setLoading(false);

        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setSeverity('error');
            setResponseMessage(response.data);
            setIsError(true);
            select();
            return;
        }
        var data = JSON.parse(response.data);
        let params = {
            MainRequest: jsonObj,
            DMTName: ActiveDMTName,
            OTPListRequest: data,
            BankPipe: BankPipe,
        };
        history.push('/NTDMT_SplitAmount', params);
        return;
    };

    const GenerateTransferOTP = async (request) => {
        setIsOtpDialogOpen(false);
        let jsonObj = {
            Mobile: senderMobile,
            BeneMobile: request.BeneMobile,
            Name: request.BeniName,
            BeniName: request.BeniName,
            SenderName: senderName,
            BankName: request.BankName,
            AccountNo: request.AccountNumber,
            IFSC: request.IFSC,
            BeneficiaryID: request.BeneficiaryID,
            SenderID: request.SenderID,
            PaymentType: request.PaymentType,
            RechargePin: request.RechargePin,
            Remark: request.Remark,
            DMTName: ActiveDMTName,
            IsVerify: request.isVerify,
            //Pipe: pipe,
            OriginalAmount: request.Amount,
            //MobileNo: mobile,
            DMTName: ActiveDMTName,
            PublicIP: request.PublicIP,
            Latitude: latitude,
            Longitude: longitude,
            BankPipe: BankPipe
        };
        setIsError(false);
        setLoading(true);
        var apirequest = JSON.stringify(jsonObj);
        var response = await GENERATE_OTP_ForMoneyTransfer(apirequest);
        setLoading(false);

        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setSeverity('error');
            setResponseMessage(response.data);
            setIsError(true);
            select();
            return;
        }
        var data = JSON.parse(response.data);
        let OTPVerifyRequest = data.list;
        let paramsForVerify = {
            MainRequest: request,
            OTPListRequest: OTPVerifyRequest
        };
        if (jsonObj.OriginalAmount === 1) {
            setIsOtpDialogOpen(false);
            setOpenOTP(true);
            setVerifyOTPParams(paramsForVerify);
            setOTPRefID(OTPVerifyRequest[0]?.OTPRefid);
        } else {
            let params = {
                MainRequest: jsonObj,
                DMTName: ActiveDMTName,
                OTPListRequest: data.list,
                Latitude: latitude,
                Longitude: longitude
            };
            // setSeverity('success');
            // setResponseMessage(data.list[0].Message);
            // setIsError(true);

            history.push('/NTDMT_TransactionConfirmation', params);
            //TransactionConfirmation

            jsonObj.OTPToken = data.OTPRefid;
            setConfirmAlertRequest(jsonObj);
            setIsOtpDialogOpen(true);
        }
    };

    const TransferWithOTP = async (request) => { 
        let jsonObj = {
            Mobile: Mobile,
            Name: request.BeniName,
            SenderName: senderName,
            BankName: request.BankName,
            AccountNo: request.AccountNumber,
            IFSC: request.IFSC,
            BeneficiaryID: request.BeneficiaryID,
            SenderID: request.SenderID,
            Amount: request.Amount,
            PaymentType: request.PaymentType,
            RechargePin: request.RechargePin,
            Remark: request.Remark,
            Latitude: request.Latitude,
            Longitude: request.Longitude,
            DMTName: ActiveDMTName,
            OTP: request.OTP,
            OTPRefID: request.OTPRefID,
            PublicIP: request.PublicIP,
            BankPipe: BankPipe
        };
        setIsError(false);
        setLoading(true);
        var apirequest = JSON.stringify(jsonObj);
        var response = await DMT_TRANSFER(apirequest); 
        setLoading(false);

        if (!response.isAuthorized) LOGOUT();

        setIsError(true);

        if (!response.status) {
            var dataError = JSON.parse(response.data);
            setSeverity('error');
            setResponseMessage(dataError.Message);

            setIsError(true);
            select();
            return;
        }

        var data = JSON.parse(response.data);

        setResponseAlert(data);
        setIsResponseAlertOpen(true);
        select();
    };

    const Verify = async (values) => {
        setOpenOTP(false);
        const { OTP } = values;
        var jsonObj = {
            BeneficiaryID: VerifyOTPParams.MainRequest.BeneficiaryID,
            Name: VerifyOTPParams.MainRequest.BeniName,
            SenderName: senderName,
            BankName: VerifyOTPParams.MainRequest.BankName,
            BankID: VerifyOTPParams.MainRequest.BankID,
            AccountNo: VerifyOTPParams.MainRequest.AccountNumber,
            IFSC: VerifyOTPParams.MainRequest.IFSC,
            SenderID: VerifyOTPParams.MainRequest.SenderID,
            Mobile: mobile,
            PaymentType: 'IMPS',
            Through: 'WEB',
            IsVerify: true,
            Amount: 1,
            RechargePin: VerifyOTPParams.MainRequest.RechargePin,
            Latitude: Lat,
            Longitude: Long,
            OTPRefID: otpRefID,
            OTP: OTP,
            DMTName: ActiveDMTName,
            BankPipe: BankPipe
        };

        setLoading(true);
        setIsError(false);

        var request = JSON.stringify(jsonObj);
        var response = await DMT_TRANSFER(request);

        setLoading(false);

        if (!response.isAuthorized) LOGOUT();

        setIsError(true);

        if (!response.status) {
            var dataError = JSON.parse(response.data);
            setSeverity('error');
            setResponseMessage(dataError.Message);

            setIsError(true);
            select();
            return;
        }

        setSeverity('success');
        var data = JSON.parse(response.data);

        setResponseMessage(data.Message);
        setIsError(true);
        if (formRef.current) formRef.current.handleSubmit();

        if (data.Status === 'FAILURE') {
            setSeverity('error');
            select();
            return;
        }
    };

    const Delete = async (values) => {
        let SenderID = '';
        if (isPin !== 'true') {
            SenderID = values[9];
        } else {
            SenderID = values[10];
        }

        var jsonObj = {
            BeneficiaryID: values[0],
            SenderID: SenderID,
            DMTName: ActiveDMTName,
            BankPipe: BankPipe
        };

        setLoading(true);
        setIsError(false);

        var request = JSON.stringify(jsonObj);

        var response = await BENE_DELETE(request);

        setLoading(false);

        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setSeverity('error');
            select();
            setResponseMessage(response.data);
            setIsError(true);

            return;
        }
        var data = JSON.parse(response.data);
        setResponseMessage(data.Message);
        setSeverity('success');
        select();
        if (formRef.current) formRef.current.handleSubmit();
        setIsError(true);

        if (data.IsOTPRequired === '1') {
            var param = {
                ActiveDMTName: ActiveDMTName,
                BeneData: values
            };
            history.push('/NTDMT_BeneDeleteVerify', param);
            return;
        } else {
            var param = {
                Mobile: values.Mobile,
                DMTName: ActiveDMTName
            };
            history.push('/NTDMT_SenderSearch', param);
        }
    };

    const MTTransferValidation = Yup.object({
        BeniName: Yup.string().required(PLEASE_PROVIDE_VALID + 'name'),
        BeneficiaryID: Yup.string().required(PLEASE_PROVIDE_VALID + 'bene'),
        SenderID: Yup.string().required(PLEASE_PROVIDE_VALID + 'sender'),
        BankName: Yup.string().required(PLEASE_PROVIDE_VALID + 'bank'),

        AccountNumber: Yup.string()
            .required(PLEASE_PROVIDE_VALID + 'account no')
            .min(7, PLEASE_PROVIDE_VALID + 'account no')
            .max(20, PLEASE_PROVIDE_VALID + 'account no'),

        IFSC: Yup.string()
            .required(PLEASE_PROVIDE_VALID + 'IFSC')
            .length(11, PLEASE_PROVIDE_VALID + 'IFSC'),

        Amount: Yup.number()
            .required(PLEASE_PROVIDE_VALID + 'amount')
            .min(0, PLEASE_PROVIDE_VALID + 'amount'),

        RechargePin: Yup.string().when(['IsPin'], {
            is: (isPin) => isPin === 'true',

            then: Yup.string().required('Please enter pin')
        })
    });

    const MTTransferConfirmation = async (values) => {
        setConfirmAlertRequest({});
        let SenderID = values[10];
        let RechargePin = values[6];
        if (isPin !== 'true') {
            SenderID = values[9];
            RechargePin = '';
        }
        if (RechargePin === undefined) {
            RechargePin = '';
        }
        let jsonObj = {
            BeneficiaryID: values[0],
            BeniName: values[1],
            BankName: values[2],
            AccountNumber: values[3],
            IFSC: values[4],
            Amount: values[5],
            RechargePin: RechargePin,
            SenderID: SenderID,
            OperatorID: MONEY_TRANSFER_OPERATOR_TRANSFER_CODE,
            ServiceID: MONEY_TRANSFER_CODE,
            Latitude: Lat,
            Longitude: Long,
            DMTName: ActiveDMTName
        };

        setIsError(false);

        var errorValidation = false;

        await MTTransferValidation.validate(jsonObj).catch(function (err) {
            errorValidation = true;
            setSeverity('error');
            setResponseMessage(err.message);

            setIsError(true);
            return;
        });

        if (errorValidation === true) return;

        setIsAlertOpen(true);
        setConfirmAlertRequest(jsonObj);
    };

    const VerifyConfirmation = async (values) => {
        setConfirmAlertRequest({});
        let SenderID = values[10];
        let BankID = values[11];
        let RechargePin = values[6];
        if (isPin !== 'true') {
            SenderID = values[9];
            RechargePin = '';
            BankID = values[10];
        }

        if (RechargePin === undefined) {
            RechargePin = '';
        }
        let jsonObj = {
            BeneficiaryID: values[0],
            BeniName: values[1],
            BankName: values[2],
            AccountNumber: values[3],
            IFSC: values[4],
            Amount: 1,
            RechargePin: RechargePin,
            SenderID: SenderID,
            BankID: BankID,
            OperatorID: MONEY_TRANSFER_OPERATOR_VERIFY_CODE,
            ServiceID: MONEY_TRANSFER_CODE,
            Latitude: Lat,
            Longitude: Long,
            DMTName: ActiveDMTName
        };

        var errorValidation = false;

        await MTTransferValidation.validate(jsonObj).catch(function (err) {
            errorValidation = true;
            setSeverity('error');
            setResponseMessage(err.message);
            setIsError(true);
            return;
        });

        if (errorValidation === true) return;

        setIsAlertOpen(true);
        setConfirmAlertRequest(jsonObj);
    };

    const createColumns = () => {
        var columns = [];

        columns.push({
            label: '#',
            name: 'BeneficiaryID',
            srno: true
        });

        columns.push({
            label: 'Name',
            name: 'Name'
        });
        columns.push({
            label: 'Bank',
            name: 'BankName'
        });
        columns.push({
            label: 'AccountNo',
            name: 'AccountNo'
        });

        columns.push({
            label: 'IFSC',
            name: 'IFSC'
        });
        columns.push({
            label: 'Amount',
            name: 'Amount',
            editableWithNumberOnly: true,
            length: 6
        });

        if (isPin === 'true') {
            columns.push({
                label: 'Pin',
                name: 'RechargePin',
                editableWithPinOnly: true,
                length: 4
            });
        }

        columns.push({
            label: 'Verified',
            name: 'IsVerified',
            buttonTitle: 'Verify',
            buttonOrLabel: true,
            callback: (values) => {
                VerifyConfirmation(values);
            }
        });

        columns.push({
            label: 'Transfer',
            name: 'BeneficiaryID',
            transfer: true,
            buttonTitle: 'Transfer',
            callback: (value) => {
                MTTransferConfirmation(value);
            }
        });

        columns.push({
            label: 'Delete',
            name: 'BeneficiaryID',
            icon: 'DeleteIcon',
            iconButtonWithRow: true,
            callback: (value) => {
                Delete(value);
            }
        });

        columns.push({
            label: 'SenderID',
            name: 'SenderID',
            hide: true
        });

        columns.push({
            label: 'BankID',
            name: 'BankID',
            hide: true
        });
        setMainColumns(columns);
    };

    const sendCallback = (data) => {
        setIsResponseAlertOpen(false);

        setSeverity('success');
        if (data.Status === 'FAILURE') {
            setSeverity('error');
        }
        setResponseMessage(data.Message);
        setIsError(true);
    };

    if (senderNo === undefined || senderNo === null || senderNo.length <= 5) {
        return null;
    }

    return (
        <>
            <h2 className={classes.PaperHead_h2}>Beneficiaries</h2>

            <ReactTable data={list} columns={mainColumns} />

            {isAlertOpen ? (
                <DMTTransactionConfirmation
                    isOpen={isAlertOpen}
                    ActiveDMTName={ActiveDMTName}
                    title="Domestic Money Transfer"
                    message="Are you sure to do this transaction?"
                    request={confirmAlertRequest}
                    positiveButtonClick={(request) => {
                        setIsAlertOpen(false);
                        if (
                            parseInt(request.ServiceID) ===
                            MONEY_TRANSFER_CODE &&
                            parseInt(request.OperatorID) ===
                            MONEY_TRANSFER_OPERATOR_TRANSFER_CODE
                        ) {
                            //Transfer(request);
                            // GenerateTransferOTP(request);
                            GetSplitAmountForMultipleTransaction(request);
                        }

                        if (
                            parseInt(request.ServiceID) ===
                            MONEY_TRANSFER_CODE &&
                            parseInt(request.OperatorID) ===
                            MONEY_TRANSFER_OPERATOR_VERIFY_CODE
                        ) {
                            // Verify(request);
                            const updatedRequest = {
                                ...request,
                                isVerify: true
                            };
                            GenerateTransferOTP(updatedRequest);
                        }
                    }}
                    negativeButtonClick={() => {
                        setIsAlertOpen(false);
                        select();
                    }}
                />
            ) : null}

            {isOtpDialogOpen && (
                <DMTTransactionOTPConfirmation
                    isOpen={isOtpDialogOpen}
                    ActiveDMTName={ActiveDMTName}
                    title="Domestic Money Transfer"
                    request={confirmAlertRequest}
                    positiveButtonClick={(request) => {
                        setIsOtpDialogOpen(false);
                        TransferWithOTP(request);
                    }}
                    negativeButtonClick={() => {
                        setIsOtpDialogOpen(false);
                        select();
                    }}
                />
            )}
            {isResponseAlertOpen ? (
                <TransactionResponse
                    isOpen={isResponseAlertOpen}
                    title={ResponseAlert.Status}
                    ServiceID={serviceCode}
                    request={ResponseAlert}
                    OkButtonClick={(request) => {
                        sendCallback(ResponseAlert);
                    }}
                />
            ) : null}
            {openOTP ? (
                <OTPModal
                    isOpen={openOTP}
                    title="OTP"
                    request={VerifyOTPParams}
                    error={modalErrorMessage}
                    submitCallback={(e) => {
                        Verify(e);
                        setOpenOTP(false);
                    }}
                    onDismissCallback={(value) => {
                        setOpenOTP(value);
                    }}
                />
            ) : null}
        </>
    );
}
